// extracted by mini-css-extract-plugin
var _1 = "ReportClasses__activityCalendarContainer--Pnsef";
var _2 = "ReportClasses__body--myaeV";
var _3 = "ReportClasses__categoriesClasses--RSLMk";
var _4 = "ReportClasses__categoriesSchools--JuA0x";
var _5 = "ReportClasses__categoriesStudents--SsjO_";
var _6 = "ReportClasses__dayDetails--i5fAR";
var _7 = "ReportClasses__gradeWidth--EN2HL";
var _8 = "ReportClasses__iconHeader--SvQAZ";
var _9 = "ReportClasses__infoHeader--cpQ8K ReportMainBody__infoHeader--lF1EH";
var _a = "ReportClasses__infoIcon--NINN2 ReportMainBody__infoIcon--xuLi4";
var _b = "ReportClasses__infoModal--qvgpq ReportMainBody__infoModal--YL2mA";
var _c = "ReportClasses__infoModalText--IdhPG ReportMainBody__infoModalText--uELqk";
var _d = "ReportClasses__inner--V01TT ReportClasses__body--myaeV";
var _e = "ReportClasses__link--yr9aY SchoolGeneral__tableLink--csfoW SchoolGeneral__link--tS8wu OfficeGeneral__inlineLink--J2Xk5 OfficeGeneral__inlineLinkBase--ofwQY OfficeGeneral__roboto--WQooW CoreGeneral__roboto--UlmjE";
var _f = "ReportClasses__loading--rtJA7 SchoolGeneral__loading--lfV7U";
var _10 = "ReportClasses__main--C9mTS OfficeGeneral__sectionContent--CCJVl";
var _11 = "ReportClasses__nameWidth--BeS_8";
var _12 = "ReportClasses__pcWidth--r5VZ6";
var _13 = "ReportClasses__playedWidth--BgphY";
var _14 = "ReportClasses__starWidth--bPkSw";
var _15 = "ReportClasses__statHeader--tL1ev ReportMainBody__statHeader--ZrLt2";
var _16 = "ReportClasses__statPC--AK76p ReportMainBody__statPC--d7Pjq";
var _17 = "ReportClasses__statPlayed--Clnrt ReportMainBody__statPlayed--xdmQ7";
var _18 = "ReportClasses__statStar--FtwrW ReportMainBody__statStar--d9HVn";
var _19 = "ReportClasses__statTime--gNE6l ReportMainBody__statTime--jUnZ_";
var _1a = "ReportClasses__statTrophy--mW0n5 ReportMainBody__statTrophy--VY7kc";
var _1b = "ReportClasses__studentWidth--WxpAM";
var _1c = "ReportClasses__tbLeft--lH0m8 ReportMainBody__tbLeft--kVX8Q";
var _1d = "ReportClasses__teacherWidth--QB1kH";
var _1e = "ReportClasses__timeWidth--zYWFz";
var _1f = "ReportClasses__totals4--R8B9r";
var _20 = "ReportClasses__trophyWidth--hgnrG";
export { _1 as "activityCalendarContainer", _2 as "body", _3 as "categoriesClasses", _4 as "categoriesSchools", _5 as "categoriesStudents", _6 as "dayDetails", _7 as "gradeWidth", _8 as "iconHeader", _9 as "infoHeader", _a as "infoIcon", _b as "infoModal", _c as "infoModalText", _d as "inner", _e as "link", _f as "loading", _10 as "main", _11 as "nameWidth", _12 as "pcWidth", _13 as "playedWidth", _14 as "starWidth", _15 as "statHeader", _16 as "statPC", _17 as "statPlayed", _18 as "statStar", _19 as "statTime", _1a as "statTrophy", _1b as "studentWidth", _1c as "tbLeft", _1d as "teacherWidth", _1e as "timeWidth", _1f as "totals4", _20 as "trophyWidth" }
